import { getBaseInfo } from '@/apps/assessment/model/api'
import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import { RANGE } from '../model/list'

@Component
export default class AssessmentReport extends Vue {
  private subject: any = {}
  private statusList = []
  private clazzLevelList = []
  private selectedClazz = []
  private rangeList = RANGE
  private range = []

  private get supportSubjects() {
    let supportSubjects = this.$store.state.supportSubjects
    if (supportSubjects && supportSubjects.length > 0) {
      return [{ label: '全部', value: 0, nick: 'ALL' }, ...this.$store.state.supportSubjects]
    } else {
      return []
    }
  }
  // 获取基础信息
  public async getBaseInfo() {
    const data: any = await getBaseInfo({})
    if (data.success) {
      this.statusList = data.statusList
      this.clazzLevelList = data.clazzLevelList
    }
  }

  public selectSubject(itm) {
    this.subject = itm
  }

  public mounted() {
    this.getBaseInfo()
  }
}
